const API_CONSTANTS = Object.freeze({
    API_URI_PREFIX: '/api',
});
export { API_CONSTANTS };
